import { Mail } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { CONTACT } from "@/content";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="border-t border-[#D8D4CA] bg-[#EFECE6] px-6 py-28 lg:px-10 lg:py-40">
    <div className="mx-auto grid max-w-6xl items-start gap-16 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <FadeIn>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-[#D18237]">{CONTACT.overline}</p>
          <h2 className="font-serif text-3xl leading-tight tracking-tight text-[#0A0F16] md:text-4xl">{CONTACT.title}</h2>
          <div className="mt-6 space-y-1 text-sm text-[#4A525B]">
            <p data-testid="contact-info-email">
              <a href={`mailto:${CONTACT.email}`} className="transition-colors duration-300 hover:text-[#D18237]">{CONTACT.email}</a>
            </p>
            <p data-testid="contact-info-phone">
              <a href={`tel:${CONTACT.phone.replace(/\./g, "")}`} className="transition-colors duration-300 hover:text-[#D18237]">{CONTACT.phone}</a>
            </p>
            <p data-testid="contact-info-location">{CONTACT.location}</p>
          </div>
        </FadeIn>
        <FadeIn delay={0.15}>
          <a
            data-testid="contact-email-btn"
            href={`mailto:${CONTACT.email}`}
            className="mt-10 flex items-center justify-between border border-[#122336] bg-[#122336] px-6 py-4 text-sm font-semibold uppercase tracking-[0.12em] text-[#F6F5F2] transition-colors duration-300 hover:border-[#D18237] hover:bg-[#D18237]"
          >
            <span>Email Me Directly</span>
            <Mail size={18} />
          </a>
        </FadeIn>
      </div>
      <div className="lg:col-span-5 lg:col-start-8">
        <FadeIn delay={0.2}>
          <div data-testid="melanie-photo-quote" className="flex items-start gap-6 border border-[#D8D4CA] bg-white/60 p-6">
            <img
              src="/melanie-quote.jpg"
              alt="Melanie Ann Collins on the steps of a private jet"
              className="h-44 w-32 shrink-0 object-cover object-top"
            />
            <div>
              <p className="font-serif text-base italic leading-snug text-[#122336] md:text-lg">
                "What sets Melanie apart is not simply her experience, though it is considerable. It is her character: her reliability, her trustworthiness, and her ability to make the people she serves feel genuinely cared for."
              </p>
              <p className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-[#D18237]">Susan Cotten</p>
              <p className="mt-1 text-xs text-[#4A525B]">Owner of Corporate Aircrew Placement, LLC</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </div>
  </section>
);
